import messageResource from "../messageResource"
import ATUserGroupManagementService from "./rpc/ATUserGroupManagementService";
import {UserGroupsDisabledError, NoRightsToManageAccountSettingsError} from "./errors";

export class ActionsProvider {
    constructor(groupManagementService) {
        this.groupManagementService = groupManagementService;
    }

    createUserGroup(group) {
        return this.groupManagementService.createUserGroup(group).catch(this._commonErrorsHandler)
    }

    _commonErrorsHandler(e) {
        if (e instanceof UserGroupsDisabledError) {
            alert(messageResource.getMessage('userlist.js.error_ugr_disabled'));
            document.location.reload();
        }

        if (e instanceof NoRightsToManageAccountSettingsError) {
            alert(messageResource.getMessage('group_management.permissions_changed'));
            document.location.reload();
        }

        throw e;
    }
}

export const atUserGroupManagementActionsProvider = new ActionsProvider(new ATUserGroupManagementService());


// WEBPACK FOOTER //
// ./web/js/groupManagement/actionsProviders.js